/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface GimbalRollCommand {
  utime: number;
  gimbalRoll: number;
  gimbalRollAggressiveness: number;
  gimbalRollRate: number;
  gimbalRollRateAggressiveness: number;
  maxGimbalRollRate: number;
}

function createBaseGimbalRollCommand(): GimbalRollCommand {
  return {
    utime: 0,
    gimbalRoll: 0,
    gimbalRollAggressiveness: 0,
    gimbalRollRate: 0,
    gimbalRollRateAggressiveness: 0,
    maxGimbalRollRate: 0,
  };
}

export const GimbalRollCommand = {
  encode(message: GimbalRollCommand, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.gimbalRoll !== 0) {
      writer.uint32(21).float(message.gimbalRoll);
    }
    if (message.gimbalRollAggressiveness !== 0) {
      writer.uint32(29).float(message.gimbalRollAggressiveness);
    }
    if (message.gimbalRollRate !== 0) {
      writer.uint32(37).float(message.gimbalRollRate);
    }
    if (message.gimbalRollRateAggressiveness !== 0) {
      writer.uint32(45).float(message.gimbalRollRateAggressiveness);
    }
    if (message.maxGimbalRollRate !== 0) {
      writer.uint32(53).float(message.maxGimbalRollRate);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GimbalRollCommand {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGimbalRollCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.gimbalRoll = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.gimbalRollAggressiveness = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.gimbalRollRate = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.gimbalRollRateAggressiveness = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.maxGimbalRollRate = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GimbalRollCommand {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      gimbalRoll: isSet(object.gimbalRoll) ? globalThis.Number(object.gimbalRoll) : 0,
      gimbalRollAggressiveness: isSet(object.gimbalRollAggressiveness)
        ? globalThis.Number(object.gimbalRollAggressiveness)
        : 0,
      gimbalRollRate: isSet(object.gimbalRollRate) ? globalThis.Number(object.gimbalRollRate) : 0,
      gimbalRollRateAggressiveness: isSet(object.gimbalRollRateAggressiveness)
        ? globalThis.Number(object.gimbalRollRateAggressiveness)
        : 0,
      maxGimbalRollRate: isSet(object.maxGimbalRollRate) ? globalThis.Number(object.maxGimbalRollRate) : 0,
    };
  },

  toJSON(message: GimbalRollCommand): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.gimbalRoll !== 0) {
      obj.gimbalRoll = message.gimbalRoll;
    }
    if (message.gimbalRollAggressiveness !== 0) {
      obj.gimbalRollAggressiveness = message.gimbalRollAggressiveness;
    }
    if (message.gimbalRollRate !== 0) {
      obj.gimbalRollRate = message.gimbalRollRate;
    }
    if (message.gimbalRollRateAggressiveness !== 0) {
      obj.gimbalRollRateAggressiveness = message.gimbalRollRateAggressiveness;
    }
    if (message.maxGimbalRollRate !== 0) {
      obj.maxGimbalRollRate = message.maxGimbalRollRate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GimbalRollCommand>, I>>(base?: I): GimbalRollCommand {
    return GimbalRollCommand.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GimbalRollCommand>, I>>(object: I): GimbalRollCommand {
    const message = createBaseGimbalRollCommand();
    message.utime = object.utime ?? 0;
    message.gimbalRoll = object.gimbalRoll ?? 0;
    message.gimbalRollAggressiveness = object.gimbalRollAggressiveness ?? 0;
    message.gimbalRollRate = object.gimbalRollRate ?? 0;
    message.gimbalRollRateAggressiveness = object.gimbalRollRateAggressiveness ?? 0;
    message.maxGimbalRollRate = object.maxGimbalRollRate ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
